var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"pa-0 text-button-custom",attrs:{"color":_vm.color,"disabled":_vm.disabled,"width":_vm.display === 'block' ? '100%' : 'auto',"ripple":false,"link":"","plain":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }